import { GatewayDetailTabType } from 'components/pages/GatewayDetailPage/utils';
import { ROUTE_PATH_ADMIN } from '../../configRoutes';

export const ROUTE_PATH_GATEWAYS_LIST = ROUTE_PATH_ADMIN + '/gateways';
export const ROUTE_PATH_GATEWAY_DETAIL = `${ROUTE_PATH_GATEWAYS_LIST}/:gatewayId/:tabId`;

export const getGatewaysListWithPaginationPath = ({ page, size }: { size: string; page: string }) => {
  return `${ROUTE_PATH_GATEWAYS_LIST}?page=${page}&size=${size}`;
};

export const getGatewayDetailPath = ({ gatewayId, tabId }: { gatewayId: string; tabId: GatewayDetailTabType }) => {
  return `${ROUTE_PATH_GATEWAYS_LIST}/${gatewayId}/${tabId}`;
};
